import { render, staticRenderFns } from "./updataForm.vue?vue&type=template&id=882cc7bc&scoped=true"
import script from "./updataForm.vue?vue&type=script&lang=js"
export * from "./updataForm.vue?vue&type=script&lang=js"
import style0 from "./updataForm.vue?vue&type=style&index=0&id=882cc7bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882cc7bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('882cc7bc')) {
      api.createRecord('882cc7bc', component.options)
    } else {
      api.reload('882cc7bc', component.options)
    }
    module.hot.accept("./updataForm.vue?vue&type=template&id=882cc7bc&scoped=true", function () {
      api.rerender('882cc7bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BjGraph/updataForm.vue"
export default component.exports